// あってないかも
export const isWebView = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return !!userAgent.includes( "wv" ) || !!window.ReactNativeWebView
}
